import * as generic from '@/store/generic/mutations/result-status.js'
import moment from 'moment'
export * from '@/store/modules/accounting/mutations/contractDetail'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

export function setInitializing (state, payload) {
  generic.setInitializing(state, payload)
}

// Start new mutation here
export function setContractNo (state, payload) {
  state.contractNo = payload
}

export function setContract (state, payload) {
  state.contract = payload
  state.contractStatusTransactions = payload.contractStatusTransactions
  state.interestRateDetails = payload.loan.interestRateDetails
  state.suretyDetails = payload.suretyDetails
  state.loanDetails = payload.loan.loanDetails
  state.loanDetailPlans = payload.loan.loanDetailPlans
  state.feeDetails = payload.loan.feeDetails
  state.paymentRounds = payload.loan.paymentRounds
  state.payments = payload.loan.payments
  state.files = (payload.files ? payload.files.filter(res => res.status === 'Enabled') : [])
  state.callHistories = payload.callHistories //(payload.callHistories ? payload.callHistories.filter(res => res.status === 'Enabled') : [])
  state.lawsuitHistories = payload.lawsuitHistories //(payload.lawsuitHistories ? payload.lawsuitHistories.filter(res => res.status === 'Enabled') : [])
  state.sendSmsHistories = payload.sendSmsHistories //(payload.sendSmsHistories ? payload.sendSmsHistories.filter(res => res.status === 'Enabled') : [])
  state.sendDocHistories = payload.sendDocHistories //(payload.sendDocHistories ? payload.sendDocHistories.filter(res => res.status === 'Enabled') : [])
  // console.log(state)
}

export function setContractIdsSignInStudentApp (state, payload) {
  state.contractIdsSignInStudentApp = payload
}

export function setContractOptions (state, payload) {
  state.contractOptions = payload
}

export function setContractPayments (state, payload) {
  state.payments = payload.loan.payments
  // console.log(state)
}

export function setContractWithOutAuth (state, payload) {
  state.contract = payload
}

export function setContractSuretyAppointment (state, payload) {
  state.contract = payload
  state.suretyDetails = payload.suretyDetails
}

export function setContractFiles (state, payload) {
  state.contract = payload
  state.files = (payload.files ? payload.files.filter(res => res.status === 'Enabled') : [])
  // console.log(state)
}

export function setContracts (state, payload) {
  state.contracts = payload
}

export function setContractsWithOutSmartApp (state, payload) {
  state.contracts = payload.filter(res => res.createdWith !== 'NotificationSale');
}

export function setContractsByFilters (state, payload) {
  state.contractsByFilters = payload
}

export function setContractsDashboardList (state, payload) {
  state.contractsByDashboardLists = payload
  state.contractsByDashboardListFilters = payload
}

export function setContractsDashboardListFilters (state, payload) {
  try {
    let contractsByDashboardListFilters = state.contractsByDashboardLists
    if(payload.educationStatus){
      contractsByDashboardListFilters = contractsByDashboardListFilters.filter(res => res.educationStatus === payload.educationStatus)
    }
    if(payload.year){
      contractsByDashboardListFilters = contractsByDashboardListFilters.filter(res => moment(res.contractLoanDate).format("YYYY") === payload.year.toString() )
    }
    if(payload.project){
      contractsByDashboardListFilters = contractsByDashboardListFilters.filter(res => res.borrower.project.id === payload.project)
    }
    if(payload.curriculum){
      contractsByDashboardListFilters = contractsByDashboardListFilters.filter(res => res.curriculum.id === payload.curriculum)
    }
    if(payload.loanType){
      contractsByDashboardListFilters = contractsByDashboardListFilters.filter(res => res.loan.loanType === payload.loanType)
    }
    state.contractsByDashboardListFilters = contractsByDashboardListFilters
  } catch (error) {
    // console.log(error)
    state.contractsByDashboardListFilters = state.contractsByDashboardLists
  }

}

export function setContractsNotificationList (state, payload) {
  state.contractsByNotificationLists = payload
  state.contractsByNotificationListFilters = payload
}

export function setContractsTrackDownDebtByFilters (state, payload) {
  state.contractsTrackDownDebtByFilters = payload
}

export function delContract (state, payload) {
  state.contracts = state.contracts.filter(res => res.id !== payload.id)
}

export function clearContract (state) {
  state.contract = {}
}

export function setInterestRateDetail (state, payload) {
  state.interestRateDetail = payload
}

export function setInterestRateDetails (state, payload) {
  state.interestRateDetails = payload
}

export function addInterestRateDetails (state, payload) {
  state.interestRateDetails = [...state.interestRateDetails, payload]
}

export function delInterestRateDetail (state, payload) {
  state.interestRateDetails = state.interestRateDetails.filter(res => res.id !== payload.id)
}

export function setLoanDetail (state, payload) {
  state.loanDetail = payload
}

export function setLoanDetails (state, payload) {
  state.loanDetails = payload
}

export function addLoanDetails (state, payload) {
  state.loanDetails = [...state.loanDetails, payload]
}

export function delLoanDetail (state, payload) {
  state.loanDetails = state.loanDetails.filter(res => res.id !== payload.id)
}

export function setLoanDetailPlan (state, payload) {
  state.loanDetailPlan = payload
}

export function setLoanDetailPlans (state, payload) {
  state.loanDetailPlans = payload
}

export function addLoanDetailPlan (state, payload) {
  state.loanDetailPlans = [...state.loanDetails, payload]
}

export function delLoanDetailPlan (state, payload) {
  state.loanDetailPlans = state.loanDetailPlans.filter(res => res.id !== payload.id)
}

export function setFeeDetail (state, payload) {
  state.feeDetail = payload
}

export function setFeeDetails (state, payload) {
  state.feeDetails = payload
}

export function addFeeDetails (state, payload) {
  state.feeDetails = [...state.feeDetails, payload]
}

export function delFeeDetail (state, payload) {
  state.feeDetails = state.feeDetails.filter(res => res.id !== payload.id)
}

export function setPaymentRound (state, payload) {
  state.paymentRound = payload
}

export function setPaymentRounds (state, payload) {
  state.paymentRounds = payload
}

export function addPaymentRounds (state, payload) {
  state.paymentRounds = [...state.paymentRounds, payload]
}

export function delPaymentRound (state, payload) {
  state.paymentRounds = state.paymentRounds.filter(res => res.id !== payload.id)
}

export function delPaymentRounds (state, payload) {
  const removeIndex = state.paymentRounds.length - payload.count
  state.paymentRounds = state.paymentRounds.filter(res => res.paymentRoundSeq <= removeIndex)
}

export function setPaymentRoundTransaction (state, payload) {
  state.paymentRoundTransaction = payload
}

export function setPaymentRoundTransactions (state, payload) {
  state.paymentRoundTransactions = payload
}

export function delPaymentRoundTransaction (state, payload) {
  state.paymentRoundTransactions = state.paymentRoundTransactions.filter(res => res.id !== payload.id)
}

export function setTransaction (state, payload) {
  state.transaction = payload
}

export function setTransactions (state, payload) {
  state.transactions = payload
}

export function delTransaction (state, payload) {
  state.transactions = state.transactions.filter(res => res.id !== payload.id)
}

export function setPayment (state, payload) {
  state.payment = payload
}

export function setPayments (state, payload) {
  state.payments = payload
}

export function addPayments (state, payload) {
  state.payments = [...state.payments, payload]
}

export function delPayment (state, payload) {
  state.payments = state.payments.filter(res => res.id !== payload.id)
}

export function delPayments (state, payload) {
  const removeIndex = state.payments.length - payload.count
  state.payments = state.payments.filter(res => res.paymentSeq <= removeIndex)
}

export function setFile (state, payload) {
  state.file = payload
}

export function setFiles (state, payload) {
  state.files = payload
}

export function addFiles (state, payload) {
  state.files = [...state.files, payload]
}

export function delFile (state, payload) {
  const files = state.files.filter(res => res.id !== payload.id)
  state.files = files ? files : []
}

export function toggleTransactionsLoad (state) {
  state.transactionsLoad = !state.transactionsLoad
}

export function addCallHistories (state, payload) {
  state.callHistories = [...state.callHistories, payload]
}

export function delCallHistory (state, payload) {
  state.callHistories = state.callHistories.filter(res => res.id !== payload.id)
}

export function addSendSmsHistories (state, payload) {
  state.sendSmsHistories = [...state.sendSmsHistories, payload]
}

export function delSendSmsHistory (state, payload) {
  state.sendSmsHistories = state.sendSmsHistories.filter(res => res.id !== payload.id)
}

export function addSendDocHistories (state, payload) {
  state.sendDocHistories = [...state.sendDocHistories, payload]
}

export function delSendDocHistory (state, payload) {
  state.sendDocHistories = state.sendDocHistories.filter(res => res.id !== payload.id)
}

export function addLawsuitHistories (state, payload) {
  state.lawsuitHistories = [...state.lawsuitHistories, payload]
}

export function delLawsuitHistory (state, payload) {
  state.lawsuitHistories = state.lawsuitHistories.filter(res => res.id !== payload.id)
}

export function setDashboard (state, payload) {
  const { getContractSummary, getContractGroupByAgingWithOutLawsuit, getNewContract, getCloseContract  } = payload
  state.dashboard = {
    contractSummary: getContractSummary.contractSummary,
    contractAmount: getContractSummary.contractAmount,
    contractGroupByLoanTypes: getContractSummary.contractGroupByLoanTypes,
    contractGroupByAgings: getContractGroupByAgingWithOutLawsuit,
    newContract: getNewContract.contractSummary,
    closeContract: getCloseContract.contractSummary,
  }
}

export function setCallHistoriesReceived (state, payload) {
  state.contract = {
    ...state.contract,
    callHistoriesReceivedStatus: payload.callHistoriesReceivedStatus,
    callHistoriesReceivedAt: payload.callHistoriesReceivedAt,
    callHistoriesReceivedBy: payload.callHistoriesReceivedBy
  }
}

export function setSuretyDetail (state, payload) {
  state.suretyDetail = payload
}

export function setSuretyDetailWithOutAuth (state, payload) {
  state.suretyDetail = payload
  state.contract = payload.contract
}

export function setSuretyDetails (state, payload) {
  state.suretyDetails = payload
}

export function delSuretyDetail (state, payload) {
  state.suretyDetails = state.suretyDetails.filter(res => res.id !== payload.id)
}

export function setQrPayment (state, payload) {
  state.qrPayment = payload
}
